export default "__VITE_ASSET__3e809aa4__"